import React from 'react';
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import SimilarProjects from './../Elements/SimilarProjects';
import Banner from './../Elements/Banner';
import ReactPlayer from 'react-player';

var bnrimg = require('./../../images/banner/5.jpg');

function getIconClass(name) {
    const n = name.toLowerCase();
    if (n.includes('club')) return 'fa fa-building';
    if (n.includes('cycle')) return 'fa fa-bicycle';
    if (n.includes('fitness')) return 'fa fa-heart';
    if (n.includes('children') || n.includes("kid")) return 'fa fa-child';
    if (n.includes('amphitheatre')) return 'fa fa-ticket';
    if (n.includes('cricket')) return 'fa fa-flag';
    if (n.includes('basketball')) return 'fa fa-futbol-o';
    if (n.includes('pool')) return 'fa fa-tint';
    if (n.includes('reflex')) return 'fa fa-road';
    if (n.includes('meditat') || n.includes('yoga')) return 'fa fa-leaf';
    if (n.includes('skating')) return 'fa fa-rocket';
    if (n.includes('senior')) return 'fa fa-heart';
    if (n.includes('vegetable') || n.includes('herbal') || n.includes('garden')) return 'fa fa-leaf';
    if (n.includes('community')) return 'fa fa-users';
    return 'fa fa-check';
}

class ProjectDetail extends React.Component {
    constructor(props){
        super(props);
        this.nameRef = React.createRef();
        this.emailRef = React.createRef();
        this.phoneRef = React.createRef();
        this.handleEnquirySubmit = this.handleEnquirySubmit.bind(this);
        this.subnavRef = React.createRef();
        this.placeholderRef = React.createRef();
        this.handleScroll = this.handleScroll.bind(this);
        this.updateSubnavTop = this.updateSubnavTop.bind(this);
    }

    handleEnquirySubmit(e){
        e.preventDefault();
        const name = this.nameRef.current?.value.trim();
        const email = this.emailRef.current?.value.trim();
        const phone = this.phoneRef.current?.value.trim();
        if(!name || !phone){
            alert('Please enter your name and phone number.');
            return;
        }
        const payload = { name, email, phone, page: 'Project Detail' };
        console.log('Enquiry submitted', payload);
        alert('Thank you! Your enquiry has been received. We will contact you shortly.');
        // clear form
        if(this.nameRef.current) this.nameRef.current.value = '';
        if(this.emailRef.current) this.emailRef.current.value = '';
        if(this.phoneRef.current) this.phoneRef.current.value = '';
        // close bootstrap modal if jQuery is available
        try{ if(window.$) window.$('#enquiryModal').modal('hide'); }catch(err){}
    }

    componentDidMount(){
        // record initial offset and start listeners
        if(this.subnavRef.current){
            const rect = this.subnavRef.current.getBoundingClientRect();
            this.initialTop = rect.top + window.pageYOffset;
        }
        this.updateSubnavTop();
        window.addEventListener('scroll', this.handleScroll, {passive: true});
        window.addEventListener('resize', this.updateSubnavTop);
    }

    componentWillUnmount(){
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.updateSubnavTop);
    }

    updateSubnavTop(){
        // recompute initial offset on resize
        if(this.subnavRef.current){
            const rect = this.subnavRef.current.getBoundingClientRect();
            this.initialTop = rect.top + window.pageYOffset;
        }
        this.handleScroll();
    }

    handleScroll(){
        if(!this.subnavRef.current) return;
        const header = document.querySelector('.site-header');
        const headerH = header ? header.offsetHeight : 0;
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        const shouldFix = scrollY >= (this.initialTop - headerH - 1);

                if(shouldFix){
            const el = this.subnavRef.current;
            if(!el.dataset.fixed){
                // set placeholder height to avoid layout jump
                if(this.placeholderRef.current) this.placeholderRef.current.style.height = el.offsetHeight + 'px';
                el.style.position = 'fixed';
                el.style.top = (headerH + 60) + 'px';
                el.style.left = 0;
                el.style.right = 0;
                el.style.zIndex = 1040;
                el.style.width = '100%';
                el.dataset.fixed = 'true';
            }
        } else {
            const el = this.subnavRef.current;
            if(el.dataset.fixed){
                if(this.placeholderRef.current) this.placeholderRef.current.style.height = '0px';
                el.style.position = '';
                el.style.top = '90px';
                el.style.left = '';
                el.style.right = '';
                el.style.zIndex = '';
                el.style.width = '';
                delete el.dataset.fixed;
            }
        }
    }

    render() {
        return (
            <>
                <Header />
             
                <div className="page-content">
                                <Banner title="PBVR Soham Ville – JMR Forest Weekend Luxury Villas" pagename="Project Detail" bgimage={bnrimg}/>

                                {/* Secondary in-page navigation for project detail */}
                                <div ref={this.placeholderRef}></div>
                                <div ref={this.subnavRef} className="project-subnav bg-primary text-white shadow-sm">
                                    <div className="container">
                                        <ul className="nav nav-pills justify-content-center py-2">
                                            <li className="nav-item"><a className="nav-link text-white" href="#project-overview">Overview</a></li>
                                           <li className="nav-item"><a className="nav-link text-white" href="#floorplan">Floor Plans</a></li>
                                            <li className="nav-item"><a className="nav-link text-white" href="#amenities">Amenities</a></li>
                                            <li className="nav-item"><a className="nav-link text-white" href="#location-highlights">Location Highlights</a></li>
                                            
                                            <li className="nav-item"><a className="nav-link text-white" href="#contact">Contact</a></li>
                                        </ul>
                                    </div>
                                </div>
                    
                    {/* SECTION CONTENT START */}
                  
                                        {/* SECTION CONTENT END  */}

                <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                            <div className="project-detail-outer">
                               
                               
                           

                                 <div className="m-b30">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="product-block">
                                                <div className="row">
                                                    <div className="col-md-12 m-b10">
                                                        <h4 className="text-uppercase font-weight-600 m-b10">Project</h4>
                                                        <p>PBVR Soham Ville – JMR Forest Weekend Luxury Villas</p>
                                                    </div>
                                                    <div className="col-md-12 m-b10">
                                                        <h4 className="text-uppercase font-weight-600 m-b10">Location</h4>
                                                        <p>Siddapur</p>
                                                    </div>
                                                    <div className="col-md-12 m-b10">
                                                        <h4 className="text-uppercase font-weight-600 m-b10">Total Area</h4>
                                                        <p>26.18 Acres</p>
                                                    </div>
                                                    <div className="col-md-12 m-b10">
                                                        <h4 className="text-uppercase font-weight-600 m-b10">Plots</h4>
                                                        <p>130 Luxury Villa Plots (≈ 500 Sq.Yard avg)</p>
                                                    </div>
                                                    <div className="col-md-12 m-b10">
                                                        <h4 className="text-uppercase font-weight-600 m-b10">Clubhouse</h4>
                                                        <p>15,060 Sq.Ft</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-8">
                                            <div className="mt-box">
                                                <div className="mt-thum-bx mt-img-overlay1 mt-img-effect yt-thum-box">
                                                    <img src={require('../../images/services/project1.jpg')} alt="" />
                                                    {/* <button type="button" className="play-now" data-toggle="modal" data-target="#myModal3">
                                                        <i className="icon fa fa-play" />
                                                        <span className="ripple" />
                                                    </button> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                     <div id="project-overview" className="project-detail-containt">
                                    <div className="bg-white text-black">
                                        <h3 className="font-weight-600">PBVR Soham Ville – JMR Forest Weekend Luxury Villas</h3>
                                        <p>Location: Siddapur • Total Area: 26.18 Acres • 130 Luxury Villa Plots • Avg Plot Size: 500 Sq.Yard • Clubhouse: 15,060 Sq.Ft</p>
                                        <p>PBVR Soham Ville offers a pollution‑free, green living experience set within a thoughtfully planned 26.18‑acre luxury villa enclave. The project comprises 130 premium villa plots averaging 500 sq. yards, with a spacious 15,060 sq.ft clubhouse and curated amenities focused on leisure, wellness, and community living.</p>
                                        <p>Designed for buyers seeking weekend retreats and sustainable lifestyles, the development emphasizes natural landscaping, low‑impact construction practices, and seamless integration with the surrounding environment to ensure long‑term value and healthy living.</p>
                                        <div className="m-b0">
                                            <div className="mt-divider divider-1px  bg-black"><i className="icon-dot c-square" /></div>
                                        </div>
                                        <ul className="social-icons social-square social-darkest m-b0">
                                            <li><NavLink to={"#"} className="fa fa-facebook" /></li>
                                            <li><NavLink to={"#"} className="fa fa-twitter" /></li>
                                            <li><NavLink to={"#"} className="fa fa-linkedin" /></li>
                                            <li><NavLink to={"#"} className="fa fa-rss" /></li>
                                            <li><NavLink to={"#"} className="fa fa-youtube" /></li>
                                            <li><NavLink to={"#"} className="fa fa-instagram" /></li>
                                        </ul>
                                    </div>
                                </div>
                                 <div className="m-b0">
                                    <div className="row">
                                        <div className="col-md-4 col-sm-4">
                                            <div className="project-detail-pic m-b30">
                                                <div className="mt-media">
                                                    <img src={require('./../../images/projects/portrait/pic1.jpg')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4">
                                            <div className="project-detail-pic m-b30">
                                                <div className="mt-media">
                                                    <img src={require('./../../images/projects/portrait/pic2.jpg')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4">
                                            <div className="project-detail-pic m-b30">
                                                <div className="mt-media">
                                                    <img src={require('./../../images/projects/portrait/pic3.jpg')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                          {/* Location Highlights - full width */}
                                 
                                 <section id="floorplan" className="section-full p-tb80 inner-page-padding">
    <div className="m-b50">
                                            {/* TITLE START */}
                                            <div className="section-head container">
                                                <div className="mt-separator-outer separator-left">
                                                    <div className="mt-separator">
                                                        <h2 className="text-black text-uppercase sep-line-one "><span className="font-weight-300 text-primary">checkout the plan
</span> site plans</h2>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* TITLE END */}
                                            {/* TAB DEFAULT WITH NAV BG */}
                                            <div className="section-content container">
                                                <div className="mt-tabs bg-tabs" style={{maxWidth: '100%'}}>
                                                    <ul className="nav nav-tabs">
                                                        <li className="active"><a data-toggle="tab" href="#web-design-13">Master Plan</a></li>
                                                        <li><a data-toggle="tab" href="#graphic-design-13">Floor Plan</a></li>
                                                        <li><a data-toggle="tab" href="#developement-13">Massages</a></li>
                                                    </ul>
                                                    <div className="tab-content">
                                                        <div id="web-design-13" className="tab-pane active">
                                                            <div className="text-center">
                                                                <img src={require('./../../images/services/floorplan.jpg')} alt="Master Plan - Floorplan" style={{maxWidth: '100%', height: 'auto'}} />
                                                            </div>
                                                        </div>
                                                        <div id="graphic-design-13" className="tab-pane">
                                                           <img src={require('./../../images/services/floorplan2.jpg')} alt="Master Plan - Floorplan" style={{maxWidth: '100%', height: 'auto'}} />
                                                        </div>
                                                        <div id="developement-13" className="tab-pane">
                                                            <p className="m-b0">About Us — Planning: JMR Infra Projects LLP delivers high-quality infrastructure and real-estate solutions focused on execution, governance, and customer trust.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


</section>
                                        <section id="location-highlights" className="section-full p-tb80 inner-page-padding">
                                            <div className="container-fluid px-0">
                                                <div className="row g-0 align-items-center">
                                                    <div className="col-lg-6">
                                                        <div style={{padding: '40px'}}>
                                                            <div style={{background: '#fff', padding: '28px', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.06)'}}>
                                                                <h3 className="mb-3 fw-bold" style={{color: '#0b3a57'}}>Location Highlights</h3>
                                                                <p className="text-muted mb-4">Prime connectivity and proximity to major tech and civic landmarks.</p>
                                                                <div className="row">
                                                                    <div className="col-sm-6">
                                                                        <ul className="list-unstyled" style={{lineHeight: '1.9'}}>
                                                                            <li><i className="fa fa-check" style={{color:'#216290', marginRight: 10}} />Just 8 min drive to Wipro hub, Manasapally</li>
                                                                            <li><i className="fa fa-check" style={{color:'#216290', marginRight: 10}} />Just 15 km away to Microsoft Azure, Mekaguda Data Center</li>
                                                                            <li><i className="fa fa-check" style={{color:'#216290', marginRight: 10}} />Just 12 min drive to Bangalore highway (Kottur junction)</li>
                                                                            <li><i className="fa fa-check" style={{color:'#216290', marginRight: 10}} />Just 20 min drive to JIMS Hospital</li>
                                                                            <li><i className="fa fa-check" style={{color:'#216290', marginRight: 10}} />Just 25 min drive to Amazon AWS Data Centre</li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <ul className="list-unstyled" style={{lineHeight: '1.9'}}>
                                                                            <li><i className="fa fa-check" style={{color:'#216290', marginRight: 10}} />Just 45 minutes’ drive to Gachibowli and the Financial District</li>
                                                                            <li><i className="fa fa-check" style={{color:'#216290', marginRight: 10}} />Only 20 minutes’ drive to Rajiv Gandhi International Airport</li>
                                                                            <li><i className="fa fa-check" style={{color:'#216290', marginRight: 10}} />Located close to the Electronic City and Pharma City</li>
                                                                            <li><i className="fa fa-check" style={{color:'#216290', marginRight: 10}} />Near Johnson & Johnson</li>
                                                                            <li><i className="fa fa-check" style={{color:'#216290', marginRight: 10}} />Just 20 minutes’ drive to the Statue of Equality, Sri Ramanagaram, Muchintal</li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div style={{padding: '20px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                                                            <div style={{width:'100%', maxWidth:520, borderRadius:10, overflow:'hidden', boxShadow:'0 8px 30px rgba(0,0,0,0.12)'}}>
                                                                <img src={require('./../../images/services/locationhighlights.jpg')} alt="Location Highlights" style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>

                                        {/* Amenities slider section start */}
                                        <section id="amenities" className="project-amenities pt-100 pb-100">
                                            <div className="container-fluid px-0">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="section-title text-center">
                                                            <h2 className="title">Amenities & Facilities</h2>
                                                            <p>Thoughtfully planned amenities to enrich community living.</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Background carousel - slides only change background images; the amenity grid is the same overlay for all slides */}
                                                <OwlCarousel className="amenities-bg-slider owl-theme" items={1} loop autoplay autoplayTimeout={4500} smartSpeed={800} dots={true} nav={false}>
                                                    {
                                                        (function(){
                                                            const bgImages = [
                                                                require('./../../images/banner/2.jpg'),
                                                                require('./../../images/banner/3.jpg'),
                                                                require('./../../images/banner/2.jpg')
                                                            ];

                                                            const amenities = [
                                                                'Club House - 20,000 Sq.ft',
                                                                'Cycle Track',
                                                                'Outdoor Fitness Zone',
                                                                'Children\'s Play Area',
                                                                'Amphitheatre',
                                                                'Outdoor Play Area',
                                                                'Cricket Practising Pitch',
                                                                'Half Basketball Court',
                                                                'Pool Deck',
                                                                'Kid\'s Pool',
                                                                'Lap Pool',
                                                                'Reflexology Pathway',
                                                                'Meditation Area with Trees',
                                                                'Skating Rink',
                                                                'Senior Citizen Deck',
                                                                'Vegetable Garden',
                                                                'Herbal Garden',
                                                                'Community Farming'
                                                            ];

                                                            return bgImages.map((bg, sidx) => (
                                                                <div className="item" key={sidx}>
                                                                    <div className="amenity-slide" style={{ backgroundImage: `url(${bg})`, backgroundSize: 'cover', backgroundPosition: 'center', padding: '0px 0' }}>
                                                                        <div className="overlay" style={{ background: 'rgba(0,0,0,0.75)', padding: '0px' }}>
                                                                            <div className="container">
                                                                                <div className="row">
                                                                                    {amenities.map((amen, idx) => (
                                                                                        <div className="col-md-4 col-sm-6" key={idx}>
                                                                                            <div className="amenity-box text-center" style={{ color: '#fff', padding: '18px' }}>
                                                                                                <div className="amenity-icon mb-3" style={{background: '#fff', width: 64, height: 64, borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto'}}>
                                                                                                        <i className={getIconClass(amen)} style={{ fontSize: '28px', color: '#216290' }}></i>
                                                                                                    </div>
                                                                                                <h6 className="amenity-title" style={{ color: '#fff' }}>{amen}</h6>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ));
                                                        })()
                                                    }
                                                </OwlCarousel>
                                            </div>
                                        </section>
                                        {/* Amenities slider section end */}

                                        {/* CTA full-width section */}
                                
                                            </div>
                                      
                                        {/* Amenities slider section end */}

                                     
           


                <Footer />
                {/* Floating enquiry button (right side) */}
                <button type="button" className="enquiry-now-btn" data-toggle="modal" data-target="#enquiryModal" style={{position: 'fixed', right: 20, bottom: 40, zIndex: 1060, background: '#216290', color: '#fff', border: 'none', padding: '12px 18px', borderRadius: 30, boxShadow: '0 4px 12px rgba(0,0,0,0.15)'}}>Enquiry Now</button>

                {/* Enquiry Modal */}
                <div className="modal fade" id="enquiryModal" tabIndex="-1" role="dialog" aria-labelledby="enquiryModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="enquiryModalLabel">Enquire About This Project</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <form onSubmit={this.handleEnquirySubmit}>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label>Name</label>
                                        <input ref={this.nameRef} type="text" className="form-control" placeholder="Your name" required />
                                    </div>
                                    <div className="form-group">
                                        <label>Email</label>
                                        <input ref={this.emailRef} type="email" className="form-control" placeholder="Email (optional)" />
                                    </div>
                                    <div className="form-group">
                                        <label>Phone</label>
                                        <input ref={this.phoneRef} type="tel" className="form-control" placeholder="Phone number" required />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                    <button type="submit" className="btn btn-primary" style={{background: '#216290', borderColor: '#216290'}}>Submit Enquiry</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </>
        );
    };
};

export default ProjectDetail;